exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inner-180462e3{padding:15px;display:flex;flex-flow:row wrap}.metric-916d6ed1{display:flex;align-items:baseline;width:auto;margin-bottom:0px}.metric-916d6ed1>div:first-child{margin-right:5px}.labelsUnder-cdd3c5d9{display:inline-block}.bottomMargin-023412df{margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"inner": "inner-180462e3",
	"metric": "metric-916d6ed1",
	"labelsUnder": "labelsUnder-cdd3c5d9",
	"bottomMargin": "bottomMargin-023412df"
};